import { hbdTrackEvent } from "./modules/hbdTrackEvent";
import { $listings } from "./modules/variables";

var queryEl = document.querySelector.bind(document);
var queryAllEl = document.querySelectorAll.bind(document);
var showStr = "display:block !important";
var hideStr = "display:none !important";
var debug = function () {
  return console.log.apply(console, arguments);
};
var isMobileBool = function () {
  return window.matchMedia("(max-width: 767px)").matches;
};

/**
 *  Using this instead of $.getScript because .map files are not being parsed using $.getScript
 **/
function loadJS(src, cb) {
  var ref = document.getElementsByTagName("script")[0],
    script = document.createElement("script");

  script.src = src;
  script.async = true;
  ref.parentNode.insertBefore(script, ref);

  if (cb && typeof cb === "function") {
    script.onload = cb;
  }

  return script;
}

$(function () {
  var $body = $("body"),
    $window = $(window);

  /**
   * Klick auf einen Ergebnislisteneintrag
   * Link ausführen und Klickstatistik tracken
   */
  $listings.on("click", function (ev) {
    // Business hours dropdown don't behave nicely
    var $listing = $(this),
      clickpos = $(ev.target).closest("[data-clickpos]").data("clickpos"),
      nodeName = ev.target.nodeName.toLowerCase();

    if (clickpos) {
      var clickObj = null,
        uid = $listing.data("uid"),
        uidPropName = $body.data("section") === "WP" ? "number" : "SID";

      for (var i = 0, len = dataLayer_tracking.length; i < len; i++) {
        var curObj = dataLayer_tracking[i];

        if (
          curObj.hasOwnProperty("event") &&
          curObj.event == "ReihungsView" &&
          curObj[uidPropName] == uid
        ) {
          clickObj = $.extend(true, {}, curObj);
          break;
        }
      }

      if (clickObj) {
        clickObj.event = "ReihungsClick";
        clickObj.clickPosition = clickpos;
        dataLayer.push(clickObj);
      }
    }

    if (
      nodeName !== "a" &&
      nodeName !== "button" &&
      $(ev.target).parents("a").length === 0 &&
      $listing.data("detail-url")
    ) {
      window.location.href = $listing.data("detail-url");
    }
  });

  $("[data-trim]").each(function (index, value) {
    var trimTo = $(value).attr("data-trim");
    if ($(value).text().length > trimTo) {
      var splitted = $(value).html().split("<br>");
      var trimmedText = "";
      var addRest = false;

      splitted.forEach(function (val) {
        if (val.length > trimTo && !addRest) {
          trimmedText +=
            val.substring(0, trimTo - 3) +
            '<span class="hideMoreDots">...</span><span class="hideMore">';
          trimmedText += val.substring(trimTo - 3, val.length);
          addRest = true;
        } else {
          trimmedText += val + "<br>";
          trimTo -= val.length;
        }
      });
      trimmedText += "</span>";
      $(value).html(trimmedText);
      $(
        '<div class="showMore"><b>Mehr anzeigen <i class="icon-arrow_down"></i></b></div>'
      ).insertAfter($(value));
      $(
        '<div class="showLess hidden"><b>Weniger anzeigen <i class="icon-arrow_up"></i></b></div>'
      ).insertAfter($(value));
    }
  });

  /* Event Handler */
  if ($(".showPhone.overlapping").length) {
    $(".showPhone").on("click", function (e) {
      $(this).addClass("overlapped").removeClass("overlapping");
      $(this).prev().addClass("overlapping").removeClass("overlapped");
    });
  }
  if ($(".showPhone.switch").length) {
    $(".showPhone").on("click", function (e) {
      $(this).next().removeClass("hidden");
      $(this).remove();
    });
  }
  if ($(".showMore").length) {
    $(".showMore").on("click", function () {
      $(this)
        .prevAll(".content")
        .children(".hideMore")
        .toggleClass("hideMore more");
      $(this)
        .prevAll(".content")
        .children(".hideMoreDots")
        .toggleClass("hideMoreDots moreDots");
      $(this).prevAll(".content").children(".max3").toggleClass("max3 more3");
      $(this).prevAll(".content").children(".max5").toggleClass("max5 more5");
      $(this).siblings(".showLess").removeClass("hidden");
      $(this).addClass("hidden");
    });
  }
  if ($(".showLess").length) {
    $(".showLess").on("click", function () {
      $(this)
        .prevAll(".content")
        .children(".more")
        .toggleClass("hideMore more");
      $(this)
        .prevAll(".content")
        .children(".moreDots")
        .toggleClass("hideMoreDots moreDots");
      $(this).prevAll(".content").children(".more3").toggleClass("max3 more3");
      $(this).prevAll(".content").children(".more5").toggleClass("max5 more5");
      $(this).siblings(".showMore").removeClass("hidden");
      $(this).addClass("hidden");
      $("html, body").animate(
        {
          scrollTop:
            $(this).closest("section").offset().top -
            $("#nav-main").height() -
            10,
        },
        0
      );
    });
  }
  if ($(".showMoreCount").length) {
    $(".showMoreCount").on("click", function () {
      var limit = $(".showMoreCount").data("count");
      var i;
      for (i = 1; i <= limit; i++) {
        $(this)
          .prevAll(".content.limitChildren")
          .children(".hideMore")
          .first()
          .removeClass("hideMore");
      }
      if (
        !$(this).prevAll(".content.limitChildren").children(".hideMore").length
      ) {
        $(this).remove();
      }
    });
  }
  if ($(".showMoreParent").length) {
    $(".showMoreParent").on("click", function () {
      $(this).siblings(".hideMore").toggleClass("hideMore more");
      $(this).siblings(".showLessParent").removeClass("hidden");
      $(this).addClass("hidden");
    });
  }
  if ($(".showLessParent").length) {
    $(".showLessParent").on("click", function () {
      $(this).siblings(".more").toggleClass("hideMore more");
      $(this).siblings(".showMoreParent").removeClass("hidden");
      $(this).addClass("hidden");
    });
  }
  if ($("#requestEdit").length) {
    $("#requestEdit").on("mouseenter mouseleave", function () {
      $("#requestEdit .popup").toggleClass("hidden");
    });
  }

  // flap out small CTA bar when businesscard is out of viewport
  var $ctabar = $("#ctabar"),
    $content = isMobileBool()
      ? $("#detail-company-header-mobile")
      : $("#detail-company-header"),
    offset =
      $("#nav-main").height() +
      (isMobileBool()
        ? 0
        : $("#searchform").height() + $("#subheader").height()),
    $nav = $("#nav-main"),
    $searchform = $("#searchform"),
    $stickyoffset = $(".sticky-offset");

  function reinitSticky() {
    $stickyoffset.each(function () {
      var $this = $(this);
      Stickyfill.remove($this[0]);
      $this.css("top", $nav.height() + $searchform.height() + 15);
      Stickyfill.add($this[0]);
    });
  }

  if ($ctabar.length && $content.length) {
    var $flapTop = $content.offset().top + $content.height() - offset;

    $window.on("scroll", function () {
      if ($window.scrollTop() > $flapTop) {
        if ($ctabar.is(":hidden")) {
          $ctabar.slideDown(function () {
            reinitSticky();
          });
        }
      } else {
        $ctabar.slideUp(function () {
          if ($ctabar.is(":visible")) {
            reinitSticky();
          }
        });
      }
    });
  }

  $stickyoffset.css("top", $nav.height() + $searchform.height() + 15);
  $(".sticky").Stickyfill();

  // Mobile Only
  $("#toggle-search").on("click", function () {
    window.scrollTo(0, 0);
    $("#navbar-md-down").collapse("hide");
    $("#searchform").collapse("toggle");
  });
  $("#toggle-menu").on("click", function () {
    $("#searchbar-md-down").collapse("hide");
    $("#searchform").collapse("hide");
  });

  $("#showAllFilters").on("click", function () {
    var $this = $(this).children("div"),
      oldText = $this.text();
    $this.text($this.data("toggle-text")).data("toggle-text", oldText);
    $this.parent().toggleClass($this.data("toggle-parent-class"));
    $(".filterDropdowns .col-12:nth-child(n+3)").toggleClass("hidden");
  });

  var wpCollapseEls = document.querySelectorAll(".wpTextCollapse .ellip");
  wpCollapseEls = [].slice.call(wpCollapseEls); //IE11 Hack
  wpCollapseEls.forEach(function (el) {
    if (el.scrollWidth > $(el).innerWidth()) {
      $(el).siblings(".icons").removeClass("hidden");
      $(el).on("close", function () {
        $(this).parent().addClass("collapsed");
      });
      $(el).on("open", function () {
        $(this).parent().removeClass("collapsed");
      });
      $(el)
        .parent()
        .on("click", function () {
          if ($(this).hasClass("collapsed")) {
            $(".wpTextCollapse").addClass("collapsed");
            $(el).trigger("open");
          } else {
            $(el).trigger("close");
          }
        });
    }
  });

  $(".offerDetail, .news").on("click", function (ev) {
    if (isMobileBool()) {
      if (ev.target.nodeName.toLowerCase() !== "a") {
        var $this = $(this);
        hbdTrackEvent(
          $this.data("category"),
          $this.data("action"),
          $this.data("label")
        );
        window.open($this.data("href"));
      }
    }
  });

  /**
   * Catban shown only when not scrolling on mobile resultlists
   */
  var $catban = $("#catban");

  if ($catban.length) {
    $window.scroll(function () {
      clearTimeout($.data(this, "scrollTimer"));
      $catban.hide();

      $.data(
        this,
        "scrollTimer",
        setTimeout(function () {
          $catban.fadeIn();
        }, 250)
      );
    });
  }

  var $catban = $("#catban");

  if ($catban.length) {
    $window.scroll(function () {
      clearTimeout($.data(this, "scrollTimer"));
      $catban.hide();

      $.data(
        this,
        "scrollTimer",
        setTimeout(function () {
          $catban.fadeIn();
        }, 250)
      );
    });
  }

  $('a[href^="#"]')
    .not("[data-toggle]")
    .on("click", function (e) {
      e.preventDefault();
      $("html, body").animate(
        {
          scrollTop:
            $($(this).attr("href")).offset().top - $("#nav-main").height() - 20,
        },
        500
      );
    });

  // click on advertisement links (not flash)
  $("[data-advno]").on("click", function (ev) {
    var advno = $(this).data("advno"),
      $atag = $(ev.target).closest("a");

    if ($atag.length) {
      hbdTrackAdv(advno, $atag.attr("href"));
    } else {
      hbdTrackAdv(advno);
    }
  });

  // track events via Google Analytics
  $("[data-action]").on("click", function () {
    var $this = $(this);

    hbdTrackEvent(
      $this.data("category"),
      $this.data("action"),
      $this.data("label"),
      $this.data("value"),
      $this.closest("[data-evloc]").data("evloc")
    );
  });

  // track yext click events
  $("[data-yexttarget]").on("click", function () {
    var $this = $(this);
    yextTrackClick(
      $this.data("yextid"),
      $this.data("yextsource"),
      $this.data("yexttarget")
    );
  });

  /**
   * Create autocomplete for searchmask (one or many autocompletes on the same page)
   */
  var $asgforms = $("form[data-asg-minlength]");

  // only load autocomplete code if there is a searchmask
  if ($asgforms.length) {
    loadJS("/scripting/lib/HBD/Autocomplete.min.js", function () {
      $asgforms.each(function () {
        var $this = $(this),
          asgMinLength = $this.data("asg-minlength"),
          asgSection = $this.data("asg-section").toLowerCase();

        $this.find("input.ac-what").each(function () {
          new HBD.Autocomplete(this, {
            type: "what",
            minLength: asgMinLength,
            section: asgSection,
          });
        });

        $this.find("input.ac-where").each(function () {
          new HBD.Autocomplete(this, {
            type: "where",
            minLength: asgMinLength,
            section: asgSection,
          });
        });
      });
    });
  }

  /**
   * Load I-Frames within modals when they are shown
   */
  $body.on("show.bs.modal show.bs.dropdown", function (e) {
    var $modal = $(e.target);

    // autoload iframe on show if src is empty
    $modal.find("iframe").each(function (i, node) {
      var $node = $(node),
        src = $node.data("src");

      if (typeof src !== "undefined" && src !== "") {
        $node.attr("src", src).data("src", "");
      }
    });
  });

  /**
   * Swap texts and classes for bootstrap collapsible content
   */
  $body.on("show.bs.collapse hide.bs.collapse", function (e) {
    var $togglers = $(
      '[data-toggle="collapse"][data-target="#' + e.target.id + '"]'
    );

    $togglers.find("[data-toggle-class]").each(function () {
      var $this = $(this),
        oldClass = $this.attr("class");

      $this
        .attr("class", $this.data("toggle-class"))
        .data("toggle-class", oldClass);
    });

    $togglers.find("[data-toggle-text]").each(function () {
      var $this = $(this),
        oldText = $this.text();

      $this.text($this.data("toggle-text")).data("toggle-text", oldText);
    });
  });

  $(".btn-show-tel").on("click", function () {
    var $btn = $(this),
      $parent = $btn.parent();

    $btn.remove();
    $parent.find(".tel-number-partial").remove();
    $parent.find(".tel-number-full").addClass("d-inline-block");
  });

  if ($.fn.tooltip) {
    if ("ontouchstart" in document.documentElement) {
      $('[data-toggle="tooltip"]').tooltip({
        template:
          '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div><div class="tooltip-close">&times;</div></div>',
        container: "body",
      });
    } else {
      $('[data-toggle="tooltip"]').tooltip({ container: "body" });
    }
  }

  if ($.fn.popover) {
    $('[data-toggle="popover"]').popover({ html: true });
  }

  /**
   * Add clear field icons
   */
  loadJS(
    "/scripting/node_modules/bootstrap4-input-clearer/bootstrap4-input-clearer.min.js",
    function () {
      $('input[name="searchterm"]').clearer({
        clearHtml: '<i class="icon-close"></i>',
        focusable: false,
      });
      $('input[name="searchregion"]').clearer({
        clearHtml: '<i class="icon-close"></i>',
        focusable: false,
      });
    }
  );

  /** Standortabfrage */
  var $where = $('input[name="searchregion"]');

  // on change of where field clear region key
  $where.on("change", function () {
    var $regkey = $(this).closest("form").find('input[name="regkey"]');
    var $lat = $(this).closest("form").find('input[name="lat"]');
    var $lng = $(this).closest("form").find('input[name="long"]');

    if ($regkey.length && $regkey.data("region-name") !== $(this).val()) {
      $regkey.val("");
    }
    if ($lat.length || $lng) {
      $lat.val("");
      $lng.val("");
    }
  });

  /**
   * searchmask on homepages
   */
  var $hero = $("#hero");

  if ($hero.length) {
    var $title = $hero.find("h1"),
      $valign = $("#hero-valign"),
      origHeight = parseInt($valign.height());

    // triggered always when tab is shown
    $hero.on("show.bs.tab", function (ev) {
      var $target = $(ev.target),
        oldSection = $(ev.relatedTarget).data("section").toLowerCase(),
        section = $target.data("section").toLowerCase();

      $hero.removeClass(oldSection + "-active").addClass(section + "-active");
      $title.html($target.data("title").replace("*BR*", "<br />"));

      if ($target.data("url-title")) {
        document.title = $target.data("url-title");
      }
      if ($target.data("section")) {
        $hero.trigger("changeMenu", $target.data("section"));
      }
    });

    $hero.on("changeMenu", function (ev, target) {
      if (target == "SN") {
        target = "WP";
      }
      $("#nav-main .nav-item").removeClass("active");
      $("#nav-main .nav-item.tab-" + target).addClass("active");
    });

    // on real click change history and track click - not if triggered via browser back
    $hero.find('a[data-toggle="tab"]').on("click", function () {
      var $this = $(this),
        section = $this.data("section").toLowerCase();

      history.pushState(section, $this.data("url-title"), $this.data("url"));
      hbdTrackEvent("Hometab", "click", section);
    });

    // triggered only on browser back
    window.addEventListener("popstate", function (e) {
      if (
        e.state !== null &&
        (e.state === "yp" || e.state === "wp" || e.state === "sn")
      ) {
        $("#" + e.state + "-tab-link").tab("show", "test");
      }
    });
  }

  /**
   * Enable responsive placeholders for input text fields
   */
  var $respInputs = $("input[data-placeholder-lg]");

  if ($respInputs.length) {
    $window
      .on("resize", function () {
        var newWidth = $window.width();

        $respInputs.each(function () {
          var $this = $(this);

          if (!$this.data("placeholder")) {
            $this.data("placeholder", $this.attr("placeholder"));
          }

          // use same breakpoint as Bootstrap 4 for lg size
          if (newWidth > 992) {
            $this.attr("placeholder", $this.data("placeholder-lg"));
          } else {
            $this.attr("placeholder", $this.data("placeholder"));
          }
        });
      })
      .resize();
  }

  /**
   * Init mobile filtering menu
   */
  var $btnfilter = $("#btn-filterall-mobile");

  if ($btnfilter.length) {
    HBD.FilterMenu.init($btnfilter);
  }

  /**
   * Init mobile sorting menu
   */
  var $btnsorting = $("#btn-sortedby-mobile");

  if ($btnfilter.length) {
    var $div = $("#menu-sort").appendTo("body");

    // click on the toggle menu on/off button
    $btnsorting.on("click", function () {
      $div.fadeIn();
    });

    // add a close button insede the menu
    $div.find(".closer").on("click", function () {
      $div.fadeOut();
    });
  }

  /**
   * load Adsense Script
   */
  if (window.addEventListener) {
    window.addEventListener("load", downloadJSAtOnload, false);
  } else if (window.attachEvent) {
    window.attachEvent("onload", downloadJSAtOnload);
  } else {
    window.onload = downloadJSAtOnload;
  }
});

function downloadJSAtOnload() {
  var element = document.createElement("script");
  element.src =
    "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
  document.body.appendChild(element);
}

/**
 *  track advertisements via Google Analytics
 */
function hbdTrackAdv(advno, ahref) {
  var clickObj = null;

  for (var i = 0, len = dataLayer_tracking.length; i < len; i++) {
    if (
      dataLayer_tracking[i].hasOwnProperty("Advnummer") &&
      dataLayer_tracking[i]["Advnummer"] == advno
    ) {
      clickObj = $.extend(true, {}, dataLayer_tracking[i]);
      break;
    }
  }

  if (clickObj) {
    clickObj["event"] = "promotionClick";
    clickObj["ecommerce"]["promoClick"] = clickObj["ecommerce"]["promoView"];

    if (ahref !== undefined) {
      clickObj["Landingpage"] = ahref;
    }

    delete clickObj["ecommerce"]["promoView"];
    dataLayer.push(clickObj);
  }
}

var Location = (function () {
  var $where,
    $lat,
    $lng,
    Location = function (where, lat, lng) {
      $where = where;
      $lat = lat;
      $lng = lng;
    },
    clear = function () {
      $where.val("").trigger("keyup");
      $lat.val("");
      $lng.val("");
    };

  Location.prototype = {
    constructor: Location,
    address: null,
    lat: 0,
    lng: 0,

    fill: function () {
      if (!("geolocation" in navigator)) return;

      var cancelSearch = false;

      $where.val("Suche aktuellen Standort...").trigger("change");

      var evHandler = function () {
        cancelSearch = true;
        clear();
        $(this).unbind(".loc", evHandler);
      };

      $where.on("click.loc", evHandler);
      $where.on("focus.loc", evHandler);

      this.getPosition(function (pos) {
        if ("error" in pos) {
          clear();
          return;
        }

        if (cancelSearch === false) {
          $lat.val(pos.lat);
          $lng.val(pos.lng);

          $where.val("Aktueller Standort");
        }
      });
    },

    getPosition: function (callback) {
      var that = this;

      navigator.geolocation.getCurrentPosition(
        function (pos) {
          that.lat = pos.coords.latitude;
          that.lng = pos.coords.longitude;

          dataLayer.push({
            Device_longitude: that.lng,
            Device_latitude: that.lat,
            event: "geodata_available",
          });

          callback.call(that, { lat: that.lat, lng: that.lng });
        },
        function (err) {
          callback.call(that, { error: err.code });
        },
        { timeout: 60000 }
      );
    },
  };

  return Location;
})();

function yextTrackClick(yextid, source, target) {
  var $img = $("#yextpixel");

  if ($img.length) {
    var src =
      $img.data("baseurl") +
      "?property=domain_web&action=click&pid=" +
      $img.data("pid") +
      "&source=" +
      source +
      "&target=" +
      target +
      "&ids=" +
      yextid +
      "&_=" +
      new Date().getTime();
    $img.attr("src", src);
  }
}

/**
 * Create a filter menu for mobile view based on existing HTML filters
 */
HBD.FilterMenu = (function () {
  var $div = $("#menu-filter");

  function showMenuPage($page) {
    $div.find(".menu-page").removeClass("active");
    $page.addClass("active");
  }

  function buildMenuPage($parentPage, $content) {
    var $page = $(
        '<div class="menu-page"><div class="closer">&times;</div><ul/></div>'
      ),
      title = $content.find("h5").text();

    $('<h4 class="icon-arrow_left">' + title + "</h4>")
      .on("click", function () {
        showMenuPage($parentPage);
      })
      .prependTo($page);

    $content.find("li").each(function () {
      var $li = $(this).clone();

      if ($li.hasClass("selected")) {
        $li.removeClass("selected").addClass("icon-ok");
      }

      $page.find("ul").append($li);
    });

    $('<li class="icon-arrow_right">' + title + "</li>")
      .on("click", function () {
        showMenuPage($page);
      })
      .appendTo($parentPage.find("ul"));

    $page.appendTo($div);
  }

  return {
    init: function ($toggler) {
      var $div = $("#menu-filter").appendTo("body"),
        $mainpage = $("#menu-filter .menu-page-main"),
        $ddgroups = $("#result-filters").find(".drilldown-group");

      // click on the toggle menu on/off button
      $toggler.on("click", function () {
        $div.fadeIn();
      });

      // loop through all level-1 items (.drilldown-group)
      $ddgroups.each(function () {
        var $ddgroup = $(this),
          $dd = $ddgroup.find(".drilldown"),
          header = $ddgroup.find("h4").text(),
          $page = $(
            '<div class="menu-page"><div class="closer">&times;</div><ul></ul></div>'
          );

        if (header === "") {
          $dd.each(function () {
            buildMenuPage($mainpage, $(this));
          });
        } else {
          $('<h4 class="icon-arrow_left">' + header + "</h4>")
            .on("click", function () {
              showMenuPage($mainpage);
            })
            .prependTo($page);

          $dd.each(function () {
            buildMenuPage($page, $(this));
          });

          $('<li class="icon-arrow_right">')
            .html(header)
            .on("click", function () {
              showMenuPage($page);
            })
            .appendTo($mainpage.find("ul"));
        }

        $page.appendTo($div);
      });

      // add a close button insede the menu
      $div.find(".closer").on("click", function () {
        $div.fadeOut();
      });

      $div.append($mainpage);
    },
  };
})();
